import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'app/store/reducers/app.reducer';
import { takeUntil } from 'rxjs/operators';
import * as ComponentInterfaces from './interfaces';

@Component({
  selector: 'app-rounded-icons',
  templateUrl: './rounded-icons.component.html',
  styleUrls: ['./rounded-icons.component.scss']
})
export class RoundedIconsComponent implements OnInit, OnDestroy {
  @Input() public title: string;
  @Input() public subTitle: string;
  @Input() public items!: any;
  @Input() public options: ComponentInterfaces.Options;

  public lang: string;
  public ngDestroyed$ = new Subject();

  constructor(private store: Store<AppState>) { }

  ngOnInit() {
    // default values for old applications of the component
    // TODO delete and fix old components
    if (!this.options || !this.options.iconType) this.options = { iconType: ComponentInterfaces.iconType.icon };

    this.store.select(state => state.utils.lang).pipe(
      takeUntil(this.ngDestroyed$)
    ).subscribe((lang: string) => {
      this.lang = lang;
    });
  }

  public ngOnDestroy() {
    this.ngDestroyed$.next();
  }

}
